<form #theForm="ngForm" id="payment-form">
  <div class="card active d-flex flex-column align-items-center justify-content-center p-2 p-md-5 gap-2">
    <h4>Subtotal: {{getTotalWOMSI | currency}}</h4>
    <h4 *ngIf="paymentPlanSelected && paymentPlanSelected != PaymentPlan.SinglePayment" class="text-success">+ Comisión bancaria por financiamiento: {{percentageForMSIUsage.toFixed(2) | currency}}</h4>
    <h1><strong>Total: {{getTotal | currency}}</strong></h1>
    <h2>Pago con tarjeta de crédito o débito</h2>
    <div class="payment-container w-100 row justify-content-center">
      <div class="cards-container row mt-4">
        <div class="credit col-12 col-lg-4">
          <p>Tarjetas de crédito</p>
          <img src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/cards1.png" alt="">
        </div>
        <div class="debit col-12 col-lg-8">
          <p>Tarjetas de débito</p>
          <img src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/cards2.png" alt="">
        </div>
      </div>
      <div class="row gy-2">
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline" floatLabel="always" class="w-100">
            <mat-label>Nombre del titular</mat-label>
            <input matInput type="text" placeholder="Como aparece en la tarjeta" id="holderName" name="holderName" required
              [(ngModel)]="cardObject.holderName">
            <mat-error *ngIf="theForm.form.hasError('required', ['holderName'])">Completa este campo</mat-error>
          </mat-form-field>
        </div>

        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline" floatLabel="always" class="w-100">
            <mat-label>Correo electrónico</mat-label>
            <input matInput type="text" placeholder="ejemplo@dominio.com" id="email" name="email" required
              [(ngModel)]="cardObject.holderEmail">
            <mat-error *ngIf="theForm.form.hasError('required', ['holderEmail'])">Completa este campo</mat-error>
          </mat-form-field>
        </div>

        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline" floatLabel="always" class="w-100">
            <mat-label>Número de tarjeta</mat-label>
            <input matInput openpayCardNumber name="cardNumber" id="cardNumber" required minlength="16"
              (onCardNumber)="onCardNumberChange($event)">
            <mat-error *ngIf="theForm.form.hasError('required', ['cardNumber'])">Completa este campo</mat-error>
            <mat-error *ngIf="theForm.form.hasError('minlength', ['cardNumber'])">Tamaño de número invalido</mat-error>
          </mat-form-field>
        </div>

        <div class="col-12">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-3">
              <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                <mat-label>Mes</mat-label>
                <mat-select [(ngModel)]="cardObject.expirationMonth" name="expirationMonth" id="expirationMonth" required>
                  <mat-option *ngFor="let month of cardMonths" [value]="month.value">{{month.value}}</mat-option>
                </mat-select>
                <mat-error *ngIf="theForm.form.hasError('required', ['expirationMonth'])">Completa este campo</mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                <mat-label>Año</mat-label>
                <input matInput placeholder="YY" openpayExpirationYear name="expirationYear" id="expirationYear" required
                  [(ngModel)]="cardObject.expirationYear">
                <mat-error *ngIf="theForm.form.hasError('required', ['expirationYear'])">Completa este campo</mat-error>
              </mat-form-field>
            </div>

            <div class="col-12 col-md-12 col-lg-6 row">
              <div class="col-8">
                <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                  <mat-label>Código de Seguridad</mat-label>
                  <input matInput placeholder="3 ó 4 digitos" cvv2 name="cvv2" id="cvv2" required
                    [(ngModel)]="cardObject.cvv2">
                  <mat-error *ngIf="theForm.form.hasError('required', ['cvv2'])">Completa este campo</mat-error>
                </mat-form-field>
              </div>
              <div class="col-4">
                <img src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/cvv.png" alt="">
              </div>
            </div>
            <div class="col-12">
              <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                <mat-label>Plan de pago</mat-label>
                <mat-select [(ngModel)]="paymentPlanSelected" name="paymentPlan" id="paymentPlan" required (selectionChange)="calculatePercentageForMSIUsage()">
                  <mat-option *ngFor="let paymentPlan of openPayPaymentPlanArray" [value]="paymentPlan.value">{{paymentPlan.label}}</mat-option>
                </mat-select>
                <mat-error *ngIf="theForm.form.hasError('required', ['paymentPlan'])">Selecciona una opción de pago</mat-error>
              </mat-form-field>
              <div class="fw-semibold text-success" *ngIf="paymentPlanSelected && paymentPlanSelected != PaymentPlan.SinglePayment">+ Comisión bancaria por financiamiento {{percentageForMSIUsage | currency}}.</div>
            </div>
          </div>
        </div>
        <div class="openpay">
          <div class="d-flex align-items-center gap-2">
            <img class="security-img" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/security.png" alt="">
            <p>Tus pagos se realizan de forma segura con encriptación de 256 bits</p>
          </div>
        </div>
        <div class="text-center text-md-end mt-2">
          <button mat-button class="button secondary-button p-2" (click)="onClickPay()" style="min-width: 150px;" id="payment-button">Pagar</button>
        </div>
      </div>
    </div>
  </div>
</form>

<app-dialog #processingPaymentDialog [enableCloseDialogButton]="false" [preventCloseFromBackDrop]="true" [enableConfirmButton]="false" [show]="isLoading" height="90%" width="60%">
  <div>
    <div class="w-50 mx-auto d-flex flex-column gap-5 p-4 justify-content-center align-items-center">
      <h2 class="col text-center">Procesando compra</h2>
      <app-loading size="64px"></app-loading>
      <p>Se estan verificando los datos de pago, espera un momento...</p>
    </div>
  </div>
</app-dialog>
